import { useRegisterAddonStore } from '~/stores/user-register-addon.store.ts'
export function useRegisterAddon() {
  onMounted(() => {
    const store = useRegisterAddonStore()
    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())
    const AFF_PARAM_KEYS = ['a', 'utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content']
    let forceUpdateStore = false
    for (const key in params) {
      if (AFF_PARAM_KEYS.includes(key)) {
        forceUpdateStore = true
      }
    }
    if (forceUpdateStore) {
      store.setRegisterAddon(params)
    }
  })
}
